module.exports = __webpack_public_path__ + "fonts/iconfont.89fa87e.ttf";